module.exports = __webpack_public_path__ + "Flag-40.c8aaefbb9e38f3cc915bed4384c1114b.svg";